import { clsx } from 'clsx'

export const DiffLayout = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: `minmax(0, 1fr) minmax(0, 64px) minmax(0, 1fr)`,
    }}
    className={clsx(
      'relative mb-36 gap-y-18 mt-14',
      'before:-translate-x-1/2 before:fixed before:top-0 before:bottom-0 before:left-1/2 before:z-50 before:w-px before:bg-dark-border-solid before:content-[""]',
      className
    )}
  >
    {children}
  </div>
)
